export default "__VITE_ASSET__DsdP77Dr__"